import React, { useState } from "react";
import axios from "axios";
import { config } from "../../../../config";

const apiUrl = config.apiUrl;

const CreateChat = ({ onChatCreated }) => {
  const [formData, setFormData] = useState({
    slug: "",
    name: "",
    email: "",
    whatsapp: "",
    message: "",
    messageTime: "",
  });

  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`${apiUrl}/chats`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      alert("Chat Created Successfully!");
      onChatCreated();
    } catch (err) {
      setError("An error occurred while creating the chat.");
    }
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Chat</h2>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">WhatsApp</label>
          <input
            type="text"
            name="whatsapp"
            value={formData.whatsapp}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Message</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="border w-full p-2"
          ></textarea>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Message Time</label>
          <input
            type="number"
            name="messageTime"
            value={formData.messageTime}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Create Chat
        </button>
      </form>
    </div>
  );
};

export default CreateChat;
